import uuid from "uuid";

const libKey = "library";

interface LibEntry {
  id: string;
  name: string;
  message: any;
  subject: string;
}

class LibraryStorage {
  saveMessage(name: string, subject: string, message: any) {
    const lib = JSON.parse(localStorage.getItem(libKey) || "[]");
    const id = uuid.v4();

    lib.push({
      id,
      name,
      message,
      subject,
    });

    localStorage.setItem(libKey, JSON.stringify(lib));

    return lib;
  }

  getAll(): LibEntry[] {
    return this.sortLib(JSON.parse(localStorage.getItem(libKey) || "[]"));
  }

  delete(id: string) {
    const lib = JSON.parse(localStorage.getItem(libKey) || "[]");

    const newLib = lib.filter((item: any) => item.id !== id);

    localStorage.setItem(libKey, JSON.stringify(newLib));

    return this.sortLib(newLib);
  }

  clear() {
    localStorage.removeItem(libKey);
  }

  updateMessage(id: string, message: any) {
    const lib = JSON.parse(localStorage.getItem(libKey) || "[]");

    const newLib = lib.map((item: any) => {
      if (item.id === id) {
        return { ...item, message };
      }

      return item;
    });

    localStorage.setItem(libKey, JSON.stringify(newLib));

    return this.sortLib(newLib);
  }

  private sortLib(lib: LibEntry[]): LibEntry[] {
    return lib.sort((a, b) => a.name.localeCompare(b.name));
  }
}

export const libraryStorage = new LibraryStorage();
